var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "profile-icon",
    d: "M18,.563a18,18,0,1,0,18,18A18,18,0,0,0,18,.563ZM18,7.53a6.387,6.387,0,1,1-6.387,6.387A6.387,6.387,0,0,1,18,7.53ZM18,32.5a13.908,13.908,0,0,1-10.633-4.95,8.092,8.092,0,0,1,7.149-4.34,1.776,1.776,0,0,1,.515.08,9.61,9.61,0,0,0,2.969.5,9.573,9.573,0,0,0,2.969-.5,1.776,1.776,0,0,1,.515-.08,8.092,8.092,0,0,1,7.149,4.34A13.908,13.908,0,0,1,18,32.5Z",
    transform: "translate(0 -0.563)",
    fill: "#c5dde0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.edfedfe314ea8db41e67cb2824cd73c5.svg";
export { ForwardRef as ReactComponent };